// extracted by mini-css-extract-plugin
export default {"content":"BrokerProject_content__Svefi","stats":"BrokerProject_stats__CuzAe","period":"BrokerProject_period__XmGcX"};